import { Button, Dialog, DialogActions, DialogContent, Fab, Grid } from '@material-ui/core';
import React from 'react';
import Utils from '../../providers/Utils';
import ChartsChestionare from './ChartsChestionare';
import { ReactComponent as SignInSolid } from './Icoane Font Awesome/sign-in-alt-solid.svg'
import html2canvas from 'html2canvas'
import SpecificComponent from '../../commons/SpecificComponent';

export default class RaportChestionare extends SpecificComponent {
    constructor(props) {
        super(props);
        this.state = {

        }
    }

    componentDidMount() {
    }


    pictureToCanvas = async (id) => {

        // console.log('id :>> ', id);


        let Cwidth = this.chartWidth()

        console.log('width :>> ', Cwidth);


        if (Cwidth > 0) {

            document.getElementById(id).style.width = Cwidth + 'px'
        }

        console.log('document.getElementById(id).offsetWidth :>> ', document.getElementById(id).offsetWidth);

        html2canvas(document.getElementById(id), {

            useCORS: true,
            width: document.getElementById(id).offsetWidth + 1000,
            height: document.getElementById(id).clientHeight + 1000,
            // windowWidth:document.getElementById(id).offsetWidth,
            windowHeight: document.getElementById(id).scrollHeight + 1000,
            x: 0,
            y: window.pageYOffset
        }).then(async (canvas) => {



            let img = canvas.toDataURL("image/png")

            console.log('canvas :>> ', canvas);
            let link = document.createElement('a');
            link.download = 'file.png'
            link.href = img
            link.click()


            let file = await fetch(img)

            let myFile;

            let idEv = this.props.ideval

            if (file.ok) {
                let res = await file.blob()

                if (res) {
                    myFile = new File([res], "NewCanvas", { type: res.type })
                }
            }





        });

        document.getElementById(id).style.width = '100%'
    }


    chartWidth = () => {

        console.warn('this.props.raspunsuri :>> ', this.props.raspunsuri);


        let chartWidth = 0


        let raport = [...this.props.raport.raport_data.intrebari]


        for (let i = 0, n = raport.length; i < n; i++) {

            raport[i].chartWidth = 0

            for (let j = 0, m = raport[i].raspunsuri.length; j < m; j++) {
                if (raport[i].raspunsuri[j].rezultate.length > 4) {

                    raport[i].chartWidth += 150

                    for (let k = 0, l = raport[i].raspunsuri[j].rezultate.length; k < l; k++) {
                        raport[i].chartWidth += 50
                    }
                }

            }






        }

        console.log('raport :>> ', raport);

        return Math.max.apply(Math, raport.map(r => r.chartWidth))




    }


    scrollRight = (idx) => {
        let container = document.getElementsByClassName('scroll-detaliu');
    
        // console.log('container :', container);
    
    
        

            
    
          // console.log('container[i] :>> ', container[i]);
          let containerScroll = container[idx].scrollLeft
    
          // console.log('containerScroll :>> ', containerScroll);
    
          container[idx].scrollTo({
            top: 0,
            left: containerScroll + 250,
            behavior: 'smooth'
          })
        
    
    
      }
    
      scrollLeft = (idx) => {
        let container = document.getElementsByClassName('scroll-detaliu');
    
        // console.log('container :', container);
    
    
  
          let containerScroll = container[idx].scrollLeft
    
          // console.log('containerScroll :>> ', containerScroll);
    
          container[idx].scrollTo({
            top: 0,
            left: containerScroll - 250,
            behavior: 'smooth'
          })
        
      }

    u = new Utils()
    render() {
        return (
            <div>
                <Dialog
                    className="pm-alert-dialog"
                    disableEscapeKeyDown
                    open={this.props.open}
                    onClose={this.props.dialogClose}
                    style={{ zIndex: 6000 }}
                    maxWidth={'md'}
                >

                    <DialogActions >
                        <Fab onClick={this.props.dialogClose}
                            className="pm-round-button-dialog"
                            style={{ boxShadow: 'none', backgroundColor: 'transparent' }}
                        >
                            <i style={{ color: 'black', fontSize: 28, fontWeight: 500 }} className='material-icons'>close</i>
                        </Fab>
                    </DialogActions>
                    <DialogContent>
                        <Grid container>
                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                <h2  >{this.props.titlu}</h2>
                            </Grid>

                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                                <Grid container>
                                    <Grid item xs={3} sm={3} md={3} lg={3} xl={3}>
                                        <h5 style={{ textAlign: 'left', fontWeight: 400, margin: 10 }}>{this.dictionary.evaluari.sesiunea}: <span style={{ fontWeight: 600 }}>{this.props.sesiune ? this.props.sesiune.nume : ''}</span></h5>
                                    </Grid>
                                    <Grid item xs={3} sm={3} md={3} lg={3} xl={3}>
                                        <h5 style={{ textAlign: 'left', fontWeight: 400, margin: 10 }}>{this.dictionary.pontaje.completare}: <span style={{ fontWeight: 600, color: this.props.raport.raport_data.completare_color }}>{this.props.raport.raport_data.completare}%</span></h5>
                                    </Grid>
                                    <Grid item xs={3} sm={3} md={3} lg={3} xl={3}>
                                        <h5 style={{ textAlign: 'left', fontWeight: 400, margin: 10 }}>{this.dictionary.evaluari.finalizatNoCaps}: <span style={{fontWeight:600, color: this.props.raport.finalizat_la_creare === 1 ? 'rgb(24 165 58)' : 'red' }}>{this.props.raport.finalizat_la_creare === 1 ? 'DA' : 'NU'}</span> </h5>
                                    </Grid>
                                </Grid>

                            </Grid>

                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                                <Grid container>
                                    <Grid style={{ textAlign: 'left', margin: '20px 0 20px 0' }} item xs={9} sm={9} md={9} lg={9} xl={9}>
                                        <div style={{ position: 'relative' }}>
                                            <input
                                                id='titluRaport'
                                                style={{ width: '90%' }}
                                                className='add-project-input'
                                                type="text"
                                                margin="normal"
                                                name='titlu'
                                                value={this.props.raport.titlu || ''}
                                                placeholder={this.dictionary.evaluari.denumireRaport}
                                                onChange={this.props.raportTitluChange}
                                                onBlur={this.props.updateTitluRaport}
                                            />




                                            <label className='inputLabelPM' htmlFor='titluRaport'>{this.dictionary.evaluari.denumireRaport}</label>

                                        </div>
                                    </Grid>
                                    <Grid style={{
                                        textAlign: 'left',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        display: 'flex'
                                    }} item xs={3} sm={3} md={3} lg={3} xl={3}>
                                        <Button className='add-button-green' onClick={() => { this.pictureToCanvas('export-canvas') }}  >
                                            <SignInSolid className=' iconSvg' style={{ marginRight: 10, width: 18, height: 18 }} />
                                 Exporta Raport
                                </Button>
                                    </Grid>
                                </Grid>
                            </Grid>


                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                <div style={{ height: '100%' }} id='export-canvas'>
                                    <Grid container>
                                        {this.props.raport.raport_data.intrebari.map((i, idx) => {
                                            return (
                                                <Grid key={idx} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                    <Grid container>
                                                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                            <h4 style={{ textAlign: 'left', marginBottom: 10 }}> {idx + 1}. {i.intrebare}</h4>
                                                        </Grid>

                                                        <Grid style={{ textAlign: 'left' }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                            <Grid container>
                                                                {i.raspunsuri.map((r, idx2) => {
                                                                    return (
                                                                        <Grid key={idx2} style={{ textAlign: 'left' }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                                            <span style={{ fontSize: 14, }}> {this.u.alfabet[idx2]}) {r.label_optiune_raspuns}</span>
                                                                        </Grid>

                                                                    )
                                                                })}
                                                            </Grid>
                                                        </Grid>

                                                        {i.raspunsuri.length > 0 &&
                                                            <Grid style={{ textAlign: 'left' }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                                <ChartsChestionare
                                                                    raspunsuri={i.raspunsuri}
                                                                    intrebari={this.props.raport.raport_data.intrebari}
                                                                />
                                                            </Grid>
                                                        }


                                                    </Grid>

                                                    <Grid container>
                                                        <Grid style={{textAlign:'left'}} item xs={6} sm={6} md={6} lg={6} xl={6} >

                                                            <Fab onClick={() =>{this.scrollLeft(idx)}} className='scroll-buttons-charts'>
                                                                <i className='material-icons'>keyboard_arrow_left</i>
                                                            </Fab>
                                                        </Grid>
                                                        <Grid style={{textAlign:'right'}} item xs={6} sm={6} md={6} lg={6} xl={6}>
                                                            <Fab onClick={()=>{this.scrollRight(idx)}} className='scroll-buttons-charts'>
                                                            <i className='material-icons'>keyboard_arrow_right</i>
                                                            </Fab>
                                                        </Grid>
                                                    </Grid>


                                                </Grid>
                                            )

                                        })}
                                    </Grid>
                                </div>

                            </Grid>
                        </Grid>
                    </DialogContent>



                </Dialog>
            </div >
        );
    }
}